export enum PaApiPath{
    Oto360 = 'pa/oto360'
}